import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
const styledTableWrapperTableStyles = css `
  width: calc(100% + var(--table-border-spacing) * 2);
  margin-inline: calc(var(--table-border-spacing) * -1);
`;
export const TableWrapper = styled.div.withConfig({ displayName: "auir-611444a-TableWrapper", componentId: "auir-611444a-14lurw0" }) `
  /* HINT: width calculation and negative margin to override table 
  ** border spacing on the sides
  */
  --table-border-spacing: 8px;
  overflow: auto;
  ${injectSpacing('margin')}

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return;
        }
        case 'table': {
            return styledTableWrapperTableStyles;
        }
        default: {
            return css `
          @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
            ${styledTableWrapperTableStyles}
          }
        `;
        }
    }
}}
`;
export const StyledTable = styled.table.withConfig({ displayName: "auir-611444a-StyledTable", componentId: "auir-611444a-1mzbcvb" }) `
  width: 100%;

  border-collapse: separate;
  text-align: start;

  border-spacing: var(--table-border-spacing) 0;
  table-layout: ${({ fixedLayout }) => (fixedLayout ? 'fixed' : 'auto')};

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return css `
          display: block;
        `;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${({ theme }) => theme.breakpoints.m - 1}px) {
            display: block;
          }
        `;
        }
    }
}}
`;
const tableCaptionListStyles = css `
  display: block;
  padding: var(${({ theme }) => theme.responsive.spacing.m}) 0;
`;
export const TableCaption = styled.caption.withConfig({ displayName: "auir-611444a-TableCaption", componentId: "auir-611444a-5nwwma" }) `
  padding: var(${({ theme }) => theme.responsive.spacing.m})
    var(--table-border-spacing);
  text-align: start;

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return tableCaptionListStyles;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${({ theme }) => theme.breakpoints.m - 1}px) {
            ${tableCaptionListStyles}
          }
        `;
        }
    }
}}
`;
const visuallyHidden = css `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const StyledTableHeader = styled.thead.withConfig({ displayName: "auir-611444a-StyledTableHeader", componentId: "auir-611444a-136o3jv" }) `
  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return visuallyHidden;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${({ theme }) => theme.breakpoints.m - 1}px) {
            ${visuallyHidden}
          }
        `;
        }
    }
}}
`;
const styledTableBodyListStyles = css `
  display: block;
  border-top: 2px solid var(${({ theme }) => theme.colors.ui.primary});
`;
export const StyledTableBody = styled.tbody.withConfig({ displayName: "auir-611444a-StyledTableBody", componentId: "auir-611444a-6ybffv" }) `
  border-top: none;

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return styledTableBodyListStyles;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${({ theme }) => theme.breakpoints.m - 1}px) {
            ${styledTableBodyListStyles}
          }
        `;
        }
    }
}}
`;
export const StyledTableFooter = styled.tfoot.withConfig({ displayName: "auir-611444a-StyledTableFooter", componentId: "auir-611444a-f680p0" }) `
  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return css `
          display: block;
        `;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${({ theme }) => theme.breakpoints.m - 1}px) {
            display: block;
          }
        `;
        }
    }
}}
`;
export const StyledTableRow = styled.tr.withConfig({ displayName: "auir-611444a-StyledTableRow", componentId: "auir-611444a-gxhoim" }) `
  vertical-align: top;

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return css `
          display: block;
        `;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${({ theme }) => theme.breakpoints.m - 1}px) {
            display: block;
          }
        `;
        }
    }
}}
`;
export const SmallScreenHeading = styled.div.withConfig({ displayName: "auir-611444a-SmallScreenHeading", componentId: "auir-611444a-10osr6i" }) `
  padding-bottom: var(${({ theme }) => theme.responsive.spacing.xs});

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return;
        }
        case 'table': {
            return css `
          display: none;
        `;
        }
        default: {
            return css `
          @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
            display: none;
          }
        `;
        }
    }
}}
`;
const topRowCellTableStyles = css `
  /* HINT: border top for all cells that can end up at the top of the table */
  thead > tr:first-child > &,
  tbody:first-child > tr:first-child > &,
  *:not(thead) + tbody > tr:first-child > & {
    border-top: 2px solid var(${({ theme }) => theme.colors.ui.primary});
  }
`;
const topRowCellStyle = css `
  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return;
        }
        case 'table': {
            return topRowCellTableStyles;
        }
        default: {
            return css `
          @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
            ${topRowCellTableStyles}
          }
        `;
        }
    }
}}
`;
const cellPadding = css `
  --cell-inline-start-padding: 2px;
  padding: ${({ theme }) => {
    const { s, l } = theme.responsive.spacing;
    return `var(${s}) var(${s}) var(${l}) var(--cell-inline-start-padding)`;
}};
`;
const styledTableHeadingCellListStyles = css `
  display: block;
  width: 100%;
  padding: ${({ theme, isColumnHeading }) => {
    const { m, l } = theme.responsive.spacing;
    return isColumnHeading ? `var(${m}) 0 var(${l})` : `var(${m}) 0`;
}};
  border-bottom: 0;
`;
export const StyledTableHeadingCell = styled.th.withConfig({ displayName: "auir-611444a-StyledTableHeadingCell", componentId: "auir-611444a-1046nwl" }) `
  box-sizing: border-box;
  width: ${({ width = 'auto' }) => width};
  text-align: start;
  border-bottom: 1px solid var(${({ theme }) => theme.colors.ui.primary});
  ${cellPadding}
  ${topRowCellStyle}

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return styledTableHeadingCellListStyles;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${(props) => props.theme.breakpoints.m - 1}px) {
            ${styledTableHeadingCellListStyles}
          }
        `;
        }
    }
}}
`;
const styledTableCellListStyles = css `
  display: block;
  width: 100%;
  padding: var(${(props) => props.theme.responsive.spacing.m}) 0
    var(${(props) => props.theme.responsive.spacing.l});
  border-bottom: 0;

  /* Extra padding when we have a header cell in a row */
  th ~ & {
    padding-top: 0;
    padding-bottom: ${({ theme, hasSmallScreenHeading }) => hasSmallScreenHeading
    ? `var(${theme.responsive.spacing.l})`
    : `var(${theme.responsive.spacing.m})`};
    padding-left: ${({ theme, hasSmallScreenHeading }) => hasSmallScreenHeading ? `var(${theme.responsive.spacing.m})` : '0'};
  }

  &:last-of-type {
    border-bottom: 1px solid var(${(props) => props.theme.colors.ui.primary});
    padding-bottom: ${({ theme }) => `var(${theme.responsive.spacing.l});`};
  }
`;
export const StyledTableCell = styled.td.withConfig({ displayName: "auir-611444a-StyledTableCell", componentId: "auir-611444a-1rogyzm" }) `
  width: ${({ width = 'auto' }) => width};
  box-sizing: border-box;
  vertical-align: top;
  border-bottom: 1px solid var(${(props) => props.theme.colors.ui.primary});
  ${cellPadding}
  ${topRowCellStyle}

  ${(props) => {
    switch (props.displayMode) {
        case 'list': {
            return styledTableCellListStyles;
        }
        case 'table': {
            return;
        }
        default: {
            return css `
          @media (max-width: ${(props) => props.theme.breakpoints.m - 1}px) {
            ${styledTableCellListStyles}
          }
        `;
        }
    }
}}
`;
//# sourceMappingURL=Table.styles.mjs.mjs.map